import React from "react";
import { View } from "@/styles/reactnative";
import CModalHeader from "../Modal/CModalHeader";
import { useTradeModalStore } from "../../../hooks/trade/modalStore";
import WithdrawLeftSection from "../../../components/WithdrawModal/WithdrawLeftSection";

const WithdrawModal = ({ setShowModal }) => {
  const { data, mutate: mutateModalStore } = useTradeModalStore();

  return (
    <View
      style={{
        alignItems: "flex-start",
        justifyContent: "flex-start",
      }}
    >
      <CModalHeader
        title={"withdraw"}
        closeModal={() => mutateModalStore({ ...data, withdrawModal: false })}
      />
      <WithdrawLeftSection width="100%" />
    </View>
  );
};

export default React.memo(WithdrawModal);
